import DashboardStore from "../DashboardStore";
import React, { FC, useEffect, useState } from "react";
import { NavigateFunction } from "react-router-dom";
import RecentPaymentIcon from "../../../../../../images/membership/dollar-blue.svg";
import {
  CountryWithStateModel,
  RecentPaymentActivityDataModel,
  RecentPaymentActivityModel,
} from "../../../shared/models";
import {
  AuthService,
  CustomButton,
  CustomLabel,
  FlexContainer,
  ITableHeaders,
  Loader,
  SapphireBlueButton,
  ToastService,
  UtilityMethods,
  withRouter,
} from "@mindmemobile/mm-shared-global";
import {  DashboardService } from "../../../shared/services";
import { RenderPaymentMethodType, TableGrid } from "../../../shared/components";
import { GridNames } from "../../../shared/enums";
import { AccountSettingsStore } from "../../../shared/store";

type IProps = {
  dashboardStore: DashboardStore;
  navigate: NavigateFunction;
  merchantAccountId: string;
  countriesWithState:CountryWithStateModel[];
};
const RecentPaymentsWidget: FC<IProps> = ({
  dashboardStore,
  navigate,
  merchantAccountId,
  countriesWithState
}) => {
  const [showLoader, setLoader] = useState(false);
  useEffect(() => {
    if (!merchantAccountId) return;
    setLoader(true);
    DashboardService.getRecentPaymentsActivity(
      AuthService.authData.accountId,
      merchantAccountId
    ).subscribe({
      next: (response) => {
        setLoader(false);
        const details = RecentPaymentActivityModel.deserializeAPIModel(
          response.result
        );
        dashboardStore.updateRecentPaymentActivities(details);
      },
      error: () => {
        ToastService.showError("Error Occured");
      },
    });
  }, [merchantAccountId]);

  function columns() {
    const columns: ITableHeaders<RecentPaymentActivityDataModel>[] = [
      {
        dataKey: "createdDate",
        title: "Date",
        cellClassName: "clickable",
        onCellClick: (e) => {
          e.stopPropagation();
        },
        onCellRender: (data: RecentPaymentActivityDataModel) => {
          if (!data.contact) return null;
          return UtilityMethods.formatDateInStringWithTime(data.createdDate);
        },
      },
      {
        dataKey: "contact",
        title: "Contact",
        cellColor: "#556bb8",
        cellClassName: "clickable",
        onCellRender: (data: RecentPaymentActivityDataModel) => {
          if (!data.contact) return null;
          return (
            <span
              onClick={() =>
                navigate(`/app/contacts/detail/${data.contact?.id}`)
              }
            >
              {data.contact?.fullName || data.contact?.email}
            </span>
          );
        },
      },
      {
        dataKey: "amount",
        title: "Amount",
        cellClassName: "recent-amount-column",
        className: "recent-amount-header",
        onCellRender: (data: RecentPaymentActivityDataModel) => {
          const amount =
            "$" + AccountSettingsStore.formatAmount(data.amount, true);
          return (
            <FlexContainer spacing={5}>
              {amount}
              <RenderPaymentMethodType
                type={data.paymentMethod?.type || ""}
                hideText={true}
              />
            </FlexContainer>
          );
        },
      },
      {
        dataKey: "success",
        title: "Status",
        onCellRender: (data: RecentPaymentActivityDataModel) => {
          return (
            <CustomButton
              color={data.colors.color}
              bgColor={data.colors.bgColor}
              className="recent-status-btn"
            >
              {data.status}
            </CustomButton>
          );
        },
      },
    ];
    return columns;
  }

  if (showLoader || !dashboardStore.paymentWidgetData) {
    return <> {new Loader(true, "", "447px").loaderComponent}</>;
  }

  const sortedPayments = (
    dashboardStore.paymentWidgetData?.payments || []
  ).sort(
    (a, b) =>
      new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime()
  );

  return (
    <>
      {" "}
      <FlexContainer
        justifyContent="space-between"
        className="activity-header-wrapper"
      >
        <div>
          <FlexContainer
            alignItems="center"
            spacing={10}
            padding="0px 0px 30px"
          >
            <img src={RecentPaymentIcon} />
            <div className="activity-card-header"> Recent Payments</div>
          </FlexContainer>
        </div>
        <div>
          <SapphireBlueButton>View</SapphireBlueButton>
        </div>
      </FlexContainer>
      <FlexContainer
        justifyContent="space-between"
        alignItems="center"
        padding="0px 0px 25px"
      >
        <div>
          <FlexContainer fxLayout="column" spacing={15}>
            <CustomLabel fontSize="14px" lineHeight="24px">
              Last 7 Days
            </CustomLabel>
            <CustomLabel fontSize="30px" lineHeight="34px" color="#2C3E50">
              {dashboardStore.paymentWidgetData?.total || 0}
            </CustomLabel>
          </FlexContainer>
        </div>
        <div>
          <FlexContainer fxLayout="column" spacing={15}>
            <CustomLabel fontSize="14px" lineHeight="24px">
              Total Amount
            </CustomLabel>
            <CustomLabel fontSize="30px" lineHeight="34px" color="#2C3E50">
              {"$" +
                AccountSettingsStore.formatAmount(
                  dashboardStore.paymentWidgetData.totalAmount,
                  true
                )}
            </CustomLabel>
          </FlexContainer>
        </div>
      </FlexContainer>
      <TableGrid
        totalItemCount={0}
        cellSpacing={20}
        data={sortedPayments || []}
        headers={columns()}
        countriesWithState={countriesWithState}
        className="recent-customer-table db-payment-plh"
        name={GridNames.Payment}
      />
    </>
  );
};

export default withRouter(RecentPaymentsWidget);
